import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Router} from '@angular/router';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {TreatyApiService} from '@features/treaty/services/treaty.service';
import {DeleteQueryAction} from '@shared/store/actions/query.actions';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class CreateTreatyDocumentContentToolLinkHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;

  commandEmitter: EventEmitter<any>;
  unSubscribe$ = new Subject<void>();

  constructor(
    private router: Router,
    private dialogService: DialogService,
    private treatyService: TreatyApiService
  ) {
    this.commandEmitter = new EventEmitter<any>();
  }

  destroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  executeCommand(command: PlatformCommand) {
    if (command.fieldValues['RedirectUrl']) {
      this.router.navigateByUrl(command.fieldValues['RedirectUrl']);
    } else {
      switch (command.name) {
        case 'SelectCountryPairCommand':
          this.onCountryPairSelect(command);
          break;
        case 'DisplayOtherVersionCommand':
          this.displayOtherVersion(command);
          break;
        default:
          this.commandEmitter.emit(command);
          break;
      }
    }
  }
  onCountryPairSelect(command: PlatformCommand) {
    // Country Pair Popup
    if (command.fieldValues['CountryPairCrossButtonClicked']) {
      this.router.navigateByUrl(`treaties`);
      return;
    }
    const dialogModel = DialogModel.create(
      'Select Country Pair',
      'TreatyCountryPairSelectorDialogComponent',
      {
        selectedCountry: command.fieldValues['CountryOne'],
        selectedCountryTwo: command.fieldValues['CountryTwo']
      },
      '950px',
      '950px'
    );
    dialogModel.isFullscreen = true;
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
      if (response.action === 'OK') {
        const selectedCountry = response.data?.input?.selectedCountry;
        const selectedCountryTwo = response.data?.input?.selectedCountryTwo;
        if (selectedCountry?.code && selectedCountryTwo?.code) {
          this.router.navigateByUrl(`treaties/${selectedCountry.code.toLowerCase()}/${selectedCountryTwo.code.toLowerCase()}`);
        }
      }
    });
  }
  displayOtherVersion(command: PlatformCommand) {
    const country1 = command.fieldValues['CountryOne'];
    const country2 = command.fieldValues['CountryTwo'];
    const documentId = command.fieldValues['DocumentId'];
    this.treatyService.getOtherVersions(country1, country2)
      .subscribe(data => {
        const otherVersions = data.map(d => {
          return {...d, isActive: documentId === d.id};
        });
        this.dialogService.showCloseDialog('PlatformToolTreatyOtherVersionPopupComponent', 'Other Versions', {
          countryOne: country1,
          countryTwo: country2,
          otherVersions: otherVersions,
          width: '600px'
        }).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
          console.log('displayOtherVersion popup response', response);
        });
      });
  }
  setSelectedTab(selectedTab: TabModel): void {
    if (selectedTab?.tabData?.DocumentId) {
      this.showSelectedMenuItemInTop(selectedTab.tabData.DocumentId);
    }
  }
  showSelectedMenuItemInTop(documentId: string, count: number = 0) {
    if (count === 5) {
      return;
    }
    const element = document.getElementById(documentId);
    if (element) {
      element.scrollIntoView(true);
      return true;
    } else {
      setTimeout(() => {
        this.showSelectedMenuItemInTop(documentId, count + 1);
      }, 1000);
    }
  }



  valueChanged($event) {
  }

}
